<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>资产订单</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="_goBack">
          <i class="el-icon-close"></i> 返回
        </el-button>
      </div>
      <el-row :gutter="20" class="text-left">
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">选择仓库：</label>
            <span>{{assetInventoryInStockInfo.shName}}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-item">
            <label class="form-label">盘点日期：</label>
            <span>{{assetInventoryInStockInfo.invTime}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-item">
            <label class="form-label">盘点说明：</label>
            <span>{{assetInventoryInStockInfo.remark}}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>入库商品</span>
      </div>
      <el-table
        :data="assetInventoryInStockInfo.inoutOrderProducts"
        border
        style="width: 100%">
        <el-table-column prop="productId" label="编号" align="center"></el-table-column>
        <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
        <el-table-column prop="specName" label="规格" align="center"></el-table-column>
        <el-table-column prop="price" label="单价" align="center"></el-table-column>
        <el-table-column prop="quantity" label="账面数量" align="center"></el-table-column>
        <el-table-column prop="invQuantity" label="盘点数量" align="center"></el-table-column>
        <el-table-column prop="willExpire" label="将过期" align="center"></el-table-column>
        <el-table-column prop="attrition" label="耗损" align="center"></el-table-column>
        <el-table-column prop="invProfit" label="盘盈" align="center"></el-table-column>
        <el-table-column prop="invLoss" label="盘亏" align="center"></el-table-column>
        <el-table-column prop="invProfitMoney" label="盘盈金额" align="center"></el-table-column>
        <el-table-column prop="invLossMoney" label="盘亏金额" align="center"></el-table-column>
        <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.state != '4466'"
              type="text"
              size="small"
              @click="_inStock(scope.row.detailId)">
              入库
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="action-buttons">
      <el-button type="warning" @click="_goBack" style="margin-right: 20px;">
        <i class="el-icon-close"></i> 取消
      </el-button>
      <el-button type="primary" @click="() => _inStock()">
        <i class="el-icon-check"></i> 批量入库
      </el-button>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryAssetInventory, queryAssetInventoryProduct, assetInventoryInStock } from '@/api/goods/assetInventoryInStockApi'

export default {
  data() {
    return {
      assetInventoryInStockInfo: {
        aiId: '',
        shId: '',
        shName: '',
        invTime: '',
        inoutOrderProducts: [],
        remark: '',
        shopId: ''
      }
    }
  },
  created() {
    this.assetInventoryInStockInfo.aiId = this.$route.query.aiId
    if (!this.assetInventoryInStockInfo.aiId) {
      this.$message.error('非法操作')
      this.$router.go(-1)
      return
    }
    this.assetInventoryInStockInfo.shopId = getShopId()
    this._queryAssetInventory()
    this.queryAssetInventoryProduct()
  },
  methods: {
    _inStock(_detailId) {
      let _products = []
      const shopId = getShopId()
      
      // 判断是单个商品入库还是批量入库
      if (_detailId && typeof _detailId === 'string') {
        // 单个商品入库
        _products.push({
          detailId: _detailId,
          shopId: shopId
        })
      } else {
        // 批量入库：筛选出未入库的商品（state != '4466'）
        if (!this.assetInventoryInStockInfo.inoutOrderProducts || this.assetInventoryInStockInfo.inoutOrderProducts.length === 0) {
          this.$message.warning('没有商品数据')
          return
        }
        
        this.assetInventoryInStockInfo.inoutOrderProducts.forEach(item => {
          // 状态不等于 '4466'（已入库）的商品可以入库
          if (item.state != '4466') {
            // 确保 detailId 存在且为字符串
            if (item.detailId && typeof item.detailId === 'string') {
              _products.push({
                detailId: item.detailId,
                shopId: shopId
              })
            } else {
              console.warn('商品缺少有效的 detailId 字段:', item)
            }
          }
        })
      }
      
      if (_products.length < 1) {
        this.$message.warning('没有待入库的商品')
        return
      }
      
      let _data = {
        aiId: this.assetInventoryInStockInfo.aiId,
        shopId: shopId,
        products: _products
      }
      
      assetInventoryInStock(_data)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(res.msg || '入库成功')
            this._goBack()
          } else {
            this.$message.error(res.msg || '入库失败')
          }
        })
        .catch(error => {
          console.error('入库失败:', error)
          this.$message.error(error.message || error || '入库失败')
        })
    },
    _goBack() {
      this.$router.go(-1)
    },
    async _queryAssetInventory() {
      const params = {
        page: 1,
        row: 1,
        aiId: this.assetInventoryInStockInfo.aiId,
        shopId: this.assetInventoryInStockInfo.shopId
      }
      
      try {
        const res = await queryAssetInventory(params)
        if (res.data && res.data.length > 0) {
          Object.assign(this.assetInventoryInStockInfo, res.data[0])
        } else {
          console.warn('未找到资产盘点详情')
          this.$message.warning('未找到资产盘点详情')
        }
      } catch (error) {
        console.error('请求资产盘点详情失败:', error)
        this.$message.error('加载资产盘点详情失败')
      }
    },
    async queryAssetInventoryProduct() {
      const params = {
        page: 1,
        row: 100,
        aiId: this.assetInventoryInStockInfo.aiId,
        shopId: this.assetInventoryInStockInfo.shopId
      }
      
      try {
        const res = await queryAssetInventoryProduct(params)
        this.assetInventoryInStockInfo.inoutOrderProducts = res.data || []
        // 为每个商品计算盘盈盘亏
        this.assetInventoryInStockInfo.inoutOrderProducts.forEach(item => {
          this._computeData(item)
        })
        // 调试信息：查看商品数据结构
        if (this.assetInventoryInStockInfo.inoutOrderProducts.length > 0) {
          console.log('商品数据示例:', this.assetInventoryInStockInfo.inoutOrderProducts[0])
          console.log('可入库商品数量:', this.assetInventoryInStockInfo.inoutOrderProducts.filter(item => item.state != '4466').length)
        }
      } catch (error) {
        console.error('请求商品列表失败:', error)
        this.$message.error('加载商品信息失败')
      }
    },
    _computeData(_inoutOrderProduct) {
      const invQuantity = parseInt(_inoutOrderProduct.invQuantity || 0)
      const quantity = parseInt(_inoutOrderProduct.quantity || 0)
      const price = parseFloat(_inoutOrderProduct.price || 0)
      
      _inoutOrderProduct.invProfit = invQuantity - quantity
      if (_inoutOrderProduct.invProfit < 0) {
        _inoutOrderProduct.invProfit = 0
      }
      _inoutOrderProduct.invLoss = quantity - invQuantity
      if (_inoutOrderProduct.invLoss < 0) {
        _inoutOrderProduct.invLoss = 0
      }
      _inoutOrderProduct.invProfitMoney = _inoutOrderProduct.invProfit * price
      _inoutOrderProduct.invLossMoney = _inoutOrderProduct.invLoss * price
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.form-item {
  margin-bottom: 18px;
}

.form-label {
  margin-right: 10px;
}

.text-left {
  text-align: left;
}

.action-buttons {
  margin-top: 20px;
  text-align: right;
}
</style>